import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button, If } from 'src/Components'
import { IconRecordVideo, IconTimes } from 'src/Components/Icon'

const propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  toggleBombBomb: PropTypes.func.isRequired
}

const ControlButton = ({ className, open, toggleBombBomb }) => (
  <Button
    danger
    iconStart={open ? IconTimes : IconRecordVideo}
    onClick={toggleBombBomb}
    className={className}
  >
    <If condition={open}>
      <FormattedMessage
        id='BombBomb.control.closeButton'
        defaultMessage='Close'
      />
    </If>
    <If condition={!open}>
      <FormattedMessage
        id='BombBomb.control.recordButton'
        defaultMessage='Record'
      />
    </If>
  </Button>
)

ControlButton.propTypes = propTypes

export default ControlButton
